<template>
<div>
  <PageTitle :route="$route">
    <template slot="action-button">
      <ActionButton
        icon="fa-plus"
        v-on:click="onClickButton"
      />
    </template>
  </PageTitle>

  <PageRowWrapper>
    <div class="col-sm-12">
      <ActiveStatusList />
    </div>
  </PageRowWrapper>
</div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import ActionButton from '@/components/button/ActionButton'
import ActiveStatusList from '@/components/settings/stock-registers/activeStatus/ActiveStatusList'

export default {
  name: 'ActiveStatus',
  components: {
    PageTitle,
    ActionButton,
    PageRowWrapper,
    ActiveStatusList
  },
  methods: {
    onClickButton (e) {
      this.$router.push({ name: 'addactivestatus' })
    }
  }
}
</script>